import React from 'react';

import { SelectedSportProvider, SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import SportsList from 'common/Widgets/SportsList/SportsList';
import SeoPageText from 'components/SeoPage/SeoPageText';

import ResultsTimeFilter from './ResultsTimeFilter/ResultsTimeFilter';
import ResultsCategories from './ResultsCategories';

const ResultsView = () => {
  const sportResultsPath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.RESULTS);

  return (
    <div className="results-page">
      <div className="results-menu">
        <SportsList parentPath={sportResultsPath} results />
        <ResultsTimeFilter />
      </div>

      <SelectedSportProvider>
        <ResultsCategories />
      </SelectedSportProvider>
      <SeoPageText />
    </div>
  );
};

export default ResultsView;
